import { ComponentRef, ViewContainerRef } from '@angular/core';
import { ChangePasswordComponent } from './change-password.component';
import { ConfirmPasswordComponent } from './confirm-password/confirm-password.component';

export class ConfirmChangePasswordFormSession {
  clientContext: any;
  viewContainerRef: ViewContainerRef;
  confirmPasswordComponent: ComponentRef<ConfirmPasswordComponent>;


  actionContext: any;
  submitHandler: any;
  mode: any;
  title: string;
  username: string;

  constructor(title, username){
      this.title = title;
      this.username = username;
  }

  startSession(
    description: com.ts.mobile.sdk.AuthenticatorDescription,
    mode: com.ts.mobile.sdk.AuthenticatorSessionMode,
    actionContext: com.ts.mobile.sdk.PolicyAction | null,
    clientContext: object | null
  ): void {
    this.actionContext = actionContext;
    this.clientContext = clientContext;
    this.mode = mode;

  }

  endSession(): void {
  }

  promiseInput(): Promise<com.ts.mobile.sdk.InputOrControlResponse<ResponseType>>{
    this.viewContainerRef = (this.clientContext as any).viewContainerRef;
    this.viewContainerRef.clear();
   
    const userEmail = this.clientContext['cookieService'].get('userEmail');


    this.confirmPasswordComponent = this.viewContainerRef.createComponent(ConfirmPasswordComponent);
    this.confirmPasswordComponent.instance.onResetPasswordSubmit = this.onResetPasswordSubmit;
    this.confirmPasswordComponent.instance.username = userEmail;


    this.confirmPasswordComponent.instance.onChangePasswordSkipClick = this.onChangePasswordSkipSubmit.bind(this);

    return new Promise((resolve, reject) => {
      this.submitHandler = (response) => {
        resolve(response);
      };
    });
  }

  promiseRecoveryForError(
    error: com.ts.mobile.sdk.AuthenticationError,
    validRecoveries: Array<com.ts.mobile.sdk.AuthenticationErrorRecovery>,
    defaultRecovery: com.ts.mobile.sdk.AuthenticationErrorRecovery
  ): Promise<com.ts.mobile.sdk.AuthenticationErrorRecovery> {
    return new Promise((resolve, reject) => {
      const userEmail = this.clientContext['cookieService'].get('username');
      const newLocal = 'additional_data';
      const errorCode = error.getData()[newLocal]?.code;
      this.clientContext['cookieService'].set('passwordExpiry',errorCode, undefined, undefined, null, true, 'None');
    });
  }

  onResetPasswordSubmit = (password: string) => {
    const inputResponse = com.ts.mobile.sdk.PasswordInput.create(password);
    const response = com.ts.mobile.sdk.InputOrControlResponse.createInputResponse(inputResponse);
    this.submitHandler(response);
  }

  onChangePasswordSkipSubmit = () => {
    const userEmail = this.clientContext['cookieService'].get('username');
    const url = this.clientContext['redirect_uri'];
    const state = this.clientContext['state'];
    const errorCode  = 'cancel_password';
    let appendChar = '?';
    if (url.includes('?'))
    {
       appendChar = '&';
    }
    window.location.href = url + appendChar + 'error=' + errorCode + '&error_description=cancel_password' 
    + '&lang=' + this.clientContext['cookieService'].get('lang')
    + '&state=' + state;
  }

}
export default ConfirmChangePasswordFormSession;
